module.exports = __webpack_public_path__ + "img/picker-empty.bfe25ff9.png";